

















































import Vue from 'vue';
import Icon from '../Icon';
import Outline from '../Outline';

export default Vue.extend({
  components: {
    Icon,
    Outline,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    inputElement: {
      type: String,
      default: 'input',
    },
    label: {
      type: String,
      default: '',
    },
    large: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
    maskFormatter: {
      type: Function,
      default: null,
    },
    outline: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      internalValue:
        this.maskFormatter !== null
          ? this.maskFormatter(this.value)
          : this.value,
      isFocused: false,
      isHovering: false,
    };
  },
  computed: {
    hasContent(): boolean {
      return !!this.value;
    },
    outlineLabelOffset(): number | null {
      const offset = this.large ? 38 : 24;
      return this.icon ? offset : null;
    },
    placeholderText(): string {
      return this.isFocused ? this.placeholder : '';
    },
  },
  watch: {
    value(newValue: string): void {
      let updatedValue = newValue;

      if (this.maskFormatter !== null) {
        updatedValue = this.maskFormatter(updatedValue);
      }

      this.forceValueUpdate(updatedValue);

      this.internalValue = updatedValue;
    },
  },
  methods: {
    blurHandler(e: any): void {
      this.isFocused = false;
      this.$emit('blur', e.target.value);
    },
    focusHandler(e: any): void {
      this.isFocused = true;
      this.$emit('focus', e.target.value);
    },
    inputHandler(e: any): void {
      this.$emit('input', e.target.value);
    },
    forceValueUpdate(value: string): void {
      const inputRef = this.$refs.input as HTMLInputElement;

      inputRef.value = value;

      const event = document.createEvent('HTMLEvents');
      event.initEvent('input', true, true);

      inputRef.dispatchEvent(event);
    },
    hoverHandler(hovering: boolean) {
      this.isHovering = hovering;
    },
  },
});
